module.exports = __webpack_public_path__ + "static/media/our-mission.b1edaf33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/our-mission.jpg
// module id = 501
// module chunks = 33